document.addEventListener('DOMContentLoaded', () => {
  const filterContainer = document.getElementById('update-filters');
  const filterButtons = filterContainer.querySelectorAll('.filter-button');
  const contentItems = document.querySelectorAll('.content-panel .content-item');

  const activeBtnClasses = ['text-cake-blue'];

  function updateDisplay(activeIndex) {
    filterButtons.forEach((btn, i) => {
      if (i.toString() === activeIndex) {
        btn.classList.add(...activeBtnClasses);
      } else {
        btn.classList.remove(...activeBtnClasses);
      }
    });

    contentItems.forEach((item, i) => {
      if (i.toString() === activeIndex) {
        item.classList.remove('hidden');
      } else {
        item.classList.add('hidden');
      }
    });
  }

  updateDisplay('0');

  filterContainer.addEventListener('click', (e) => {
    const clickedButton = e.target.closest('.filter-button');
    if (!clickedButton) return;

    const indexToShow = clickedButton.dataset.index;

    updateDisplay(indexToShow);
  });
});